export default __webpack_public_path__ + "static/media/fetured-item-1.b0cd4d0f.png";